import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const FeaturedBlogs = ({ blogs }) => {
    const [featuredBlogs, setFeaturedBlogs] = useState([]);
    useEffect(() => {
        // select random 3 blogs
        const randomBlogs = blogs.sort(() => 0.5 - Math.random()).slice(0, 3);
        setFeaturedBlogs(randomBlogs);
    }, [blogs])
    return (
        <div className="max-w-7xl mx-auto p-4">
            <h2 className="text-3xl font-bold text-white mb-6">Featured Blogs</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Large Featured Blog */}
                {
                    featuredBlogs.slice(0, 1).map((blog) => (
                        <motion.div key={blog.id} className="md:col-span-2">
                            <div className="relative rounded-lg overflow-hidden group">
                                <Link to={`/blog/${blog.id}`}>
                                    <img src={blog.coverImage} alt="blog"
                                        className="w-full h-96 object-cover transition duration-300 ease-in-out group-hover:opacity-60" />
                                    <div
                                        className="absolute inset-0 bg-indigo-900 bg-opacity-50 flex items-center justify-center transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out">
                                        <h3 className="text-white text-2xl font-semibold text-center px-4">
                                            {blog.title}
                                        </h3>
                                    </div>
                                </Link>
                            </div>
                        </motion.div>
                    ))
                }


                {/* Small Featured Blogs */}
                <div className="flex flex-col gap-2">
                    {
                        featuredBlogs.slice(1).map((blog) => {
                            return <motion.div>
                                <div className="relative rounded-lg overflow-hidden group">
                                    <Link to={`/blog/${blog.id}`}>
                                        <img src={blog.coverImage} alt="blog"
                                            className="w-full h-48 object-cover transition duration-300 ease-in-out group-hover:opacity-60" />
                                        <div
                                            className="absolute inset-0 bg-indigo-900 bg-opacity-50 flex items-center justify-center transform translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out">
                                            <h3 className="text-white text-xl font-semibold text-center px-4">
                                                {blog.title}
                                            </h3>
                                        </div>
                                    </Link>
                                </div>
                            </motion.div>
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default FeaturedBlogs;